import { atom } from 'recoil';
import { PatientRepository } from '~/domain/repository/patientRepository';

export const patientRepositoryState = atom<PatientRepository>({
    key: 'patientRepositoryState',
    default: new PatientRepository(),
});

export const selectedPatientIdState = atom<string | null>({
    key: 'selectedPatientIdState',
    default: null,
});
